import uniq from 'lodash/uniq';

export function getModelRequest(models) {
  return models.map((model) => {
    return {
      modelId: model.modelId,
      sizes: model.sizes.map((item) => {
        return {
          sizeId: item.sizeId,
          quantity: item.quantity,
        };
      }),
      sides: uniq(model.position),
    };
  });
}
